/* global TableProps */
import React, { FC } from "react";
import { SalesListRowFragment } from "lib/api";
import { Box, Divider, TablePagination, Typography } from "@mui/material";
import { Loading } from "components/utils/Loading";
import { useNavigateTo } from "hooks/useNavigateTo";
import { Go3ToolboxRoutes } from "const/Go3ToolboxRoutes";
import { PaginationSizes } from "const/pagination";
import { formatPrice } from "utils/formatters";
import { tPropertyStatus, tPropertyType } from "utils/translateBackendEnums";
import { useTranslation } from "react-i18next";

const SalesListRowMobile: FC<{ property: SalesListRowFragment; onClick: () => void }> = ({ property, onClick }) => {
    const {
        utag,
        area_entity,
        streetname1,
        streetnumber,
        askingprice,
        district_entity,
        listingowner_entity,
        propertystatus,
        propertytype,
        propertysubtype,
    } = property;

    return (
        <>
            <Box
                sx={{
                    minHeight: "4ex",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingLeft: 1,
                    paddingRight: 1,
                    fontSize: "0.85rem",
                    paddingY: 1,
                }}
                onClick={onClick}
            >
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="body1" component="div">
                        {streetname1} {streetnumber}
                        <br />
                        {area_entity?.areaname && (
                            <Typography variant="caption">
                                {district_entity?.districtname} {area_entity.areaname}
                            </Typography>
                        )}
                    </Typography>

                    <Typography variant="caption">
                        {tPropertyType(propertytype)} {tPropertyType(propertysubtype)}
                        <br />
                        {listingowner_entity?.firstname} {listingowner_entity?.surname}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", color: "#757575" }}>
                    <Typography variant="caption">{formatPrice(askingprice)}</Typography>
                    <Typography variant="caption">{tPropertyStatus(propertystatus)}</Typography>
                    <Typography variant="caption">{utag}</Typography>
                </Box>
            </Box>
            <Divider />
        </>
    );
};

const SalesListMobileTable: FC<TableProps<SalesListRowFragment>> = ({ data, loading, page, setPage, pageSize, setPageSize }) => {
    const navigate = useNavigateTo();
    const { t } = useTranslation();

    if (loading) return <Loading />;

    return (
        <>
            {data?.map((property) => (
                <SalesListRowMobile
                    key={property.key}
                    property={property}
                    onClick={() => navigate(Go3ToolboxRoutes.App.Sales.DetailsPage.fullPath, { utag: `${property.utag}` })}
                />
            ))}
            <TablePagination
                rowsPerPageOptions={PaginationSizes}
                component="div"
                count={-1}
                rowsPerPage={pageSize}
                page={page}
                labelRowsPerPage={t("translation:rows_per_page")}
                labelDisplayedRows={({ from, to }) => `${from} - ${to}`}
                onPageChange={(_, $page) => {
                    setPage($page);
                }}
                onRowsPerPageChange={(event) => {
                    const $pageSize = parseInt(event.target.value);
                    setPageSize($pageSize);
                }}
            />
        </>
    );
};

export default SalesListMobileTable;
